module.exports = __webpack_public_path__ + "static/media/Icon_menu_move_installation.df2d9d7c.svg";